<template>
  <div class="flex w-full items-center justify-center mb-4 justify-center" v-if="categories && loaded">
    <splide
      :options="options"
    >
      <splide-slide v-for="slide in categories" :key="slide.id">
        <div class="bg-local h-full flex justify-center bg-cover bg-center bg-no-repeat cursor-pointer" :style="`background-image: url('${getImage(slide, imageHeight)}');`" @click="toCategory(slide)"/>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
  data() {
    return {
      loaded: false,
      options: {
        type: 'loop',
        width: 140,
        height: 300,
        fixedHeight: 200,
        fixedWidth: 140,
        autoplay: true,
        interval: 10000,
        pauseOnHover: true,
        rewind: true,
        speed: 3000,
        gap: '4px',
        perPage: 1,
        cover: true,
        pagination: false,
        breakpoints: {
          320: {
            perPage: 1,
            arrows: true,
            width: 140,
            height: 200,
            fixedHeight: 200,
            fixedWidth: 140
          },
          420: {
            perPage: 1,
            arrows: true,
            width: 210,
            height: 300,
            fixedHeight: 300,
            fixedWidth: 210
          },
          570: {
            perPage: 1,
            arrows: true,
            width: 280,
            height: 400,
            fixedHeight: 400,
            fixedWidth: 280
          },
          768: {
            perPage: 2,
            arrows: true,
            width: 568,
            height: 400,
            fixedHeight: 400,
            fixedWidth: 280
          },
          960: {
            perPage: 2,
            arrows: true,
            width: 568,
            height: 400,
            fixedHeight: 400,
            fixedWidth: 280
          },
          1024: {
            perPage: 3,
            arrows: false,
            width: 852,
            height: 400,
            fixedHeight: 400,
            fixedWidth: 280
          },
          9999: {
            perPage: 3,
            arrows: false,
            width: 852,
            height: 400,
            fixedHeight: 400,
            fixedWidth: 280
          }
        }
      },
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    imageHeight() {
      if (this.windowWidth < 420) {
        return 200;
      } else if (this.windowWidth < 570) {
        return 300;
      } else {
        return 400;
      }
    },
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    categories() {
      return [...this.$store.getters.showcaseCategories].sort(function (a, b) {
        var ret = 1;
        if (a.sequence < b.sequence) {
          ret = -1;
        }
        return ret;
      });
    }
  },
  methods: {
    getImage(item, height) {
      const image = item.imageURL.split('.');
      const imageURL = [this.imagesURL, '/showcase%2F', image[0], '@', height, '.', image[1], '?alt=media'].join('');
      return imageURL;
    },
    toCategory(item) {
      this.$router.push({name: 'category-view', params: {category: item.id}}).catch(() => {});
    }
  },
  mounted() {
    var self = this;
    setTimeout(function () {
      self.loaded = true;
    }, 500);
  }
}

</script>
